import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import QuadrimestreCountdown from './QuadrimestreCountdown';

interface QuadrimestreSelectorProps {
  quadrimestre: string; // "Q1", "Q2", "Q3"
  ano: number;
  onChange: (q: string, ano: number) => void;
}

const QUADRIMESTRES = [
  { value: 'Q1', label: 'Q1', sublabel: 'Jan-Abr' },
  { value: 'Q2', label: 'Q2', sublabel: 'Mai-Ago' },
  { value: 'Q3', label: 'Q3', sublabel: 'Set-Dez' },
];

/** Auto-detecta o quadrimestre atual baseado no mes */
export function getQuadrimestreAtual(): { quadrimestre: string; ano: number } {
  const now = new Date();
  const mes = now.getMonth() + 1; // 1-12
  const ano = now.getFullYear();
  if (mes <= 4) return { quadrimestre: 'Q1', ano };
  if (mes <= 8) return { quadrimestre: 'Q2', ano };
  return { quadrimestre: 'Q3', ano };
}

/** Formata quadrimestre+ano para o param da API: "Q2-2025" */
export function formatQuadrimestreParam(q: string, ano: number): string {
  return `${q}-${ano}`;
}

const QuadrimestreSelector: React.FC<QuadrimestreSelectorProps> = ({ quadrimestre, ano, onChange }) => {
  const handleQuadChange = (_: React.MouseEvent<HTMLElement>, newQ: string | null) => {
    if (newQ) onChange(newQ, ano);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton size="small" onClick={() => onChange(quadrimestre, ano - 1)} title="Ano anterior">
        <ChevronLeft fontSize="small" />
      </IconButton>
      <Typography variant="body2" fontWeight={600} sx={{ minWidth: 36, textAlign: 'center' }}>
        {ano}
      </Typography>
      <IconButton size="small" onClick={() => onChange(quadrimestre, ano + 1)} title="Proximo ano">
        <ChevronRight fontSize="small" />
      </IconButton>
      <ToggleButtonGroup
        value={quadrimestre}
        exclusive
        onChange={handleQuadChange}
        size="small"
        sx={{ ml: 0.5 }}
      >
        {QUADRIMESTRES.map((q) => (
          <ToggleButton
            key={q.value}
            value={q.value}
            sx={{
              px: 1.5,
              py: 0.5,
              textTransform: 'none',
              fontSize: '0.8rem',
              lineHeight: 1.2,
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Box sx={{ fontWeight: 700 }}>{q.label}</Box>
              <Box sx={{ fontSize: '0.65rem', opacity: 0.7 }}>{q.sublabel}</Box>
            </Box>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <QuadrimestreCountdown quadrimestre={quadrimestre} ano={ano} />
    </Box>
  );
};

export default QuadrimestreSelector;
